'use strict';

var ArctickClient = require('../../../../sdk/apiClient');
var util = require('util');

function Browser() {
    ArctickClient.apply(this, arguments);
}

util.inherits(Browser, ArctickClient);

Browser.prototype.getBrowser = function () {
    var sBrowser, sUsrAg = navigator.userAgent;

    if(sUsrAg.indexOf("Chrome") > -1) {
        sBrowser = "Google Chrome";
    } else if (sUsrAg.indexOf("Safari") > -1) {
        sBrowser = "Safari";
    } else if (sUsrAg.indexOf("Opera") > -1) {
        sBrowser = "Opera";
    } else if (sUsrAg.indexOf("Firefox") > -1) {
        sBrowser = "Mozilla Firefox";
    } else if (sUsrAg.indexOf("Edge") > -1) {
        sBrowser = "Edge";
    }else if (sUsrAg.indexOf("Edg") > -1) {
        sBrowser = "Edge";
    }
    return sBrowser;
}

Browser.prototype.isPopupBlockerActivated = function () {
    var boolIsEnable = false;
	var popupWindow = window.open();
    
    if (popupWindow) {
        if (/chrome/.test(navigator.userAgent.toLowerCase())) {
            try {
                popupWindow.focus();
            } catch (e) {
                return true;
                
            }
        } else {
            popupWindow.onload = function() {               
                return (popupWindow.innerHeight > 0) === false;
            };
        }
    } else { 
        return boolIsEnable = false;
    }
    popupWindow.closed;
    popupWindow.close();
    return boolIsEnable = true;        
        
};

module.exports = Browser;